import { createSlice } from "@reduxjs/toolkit";

const doctorSlice = createSlice({
  name: "doctors",
  initialState: {
    doctorList: [],
    centerList:[],
    speacialityList:[],
    isCached: false,
    lastFetched: null,
  },
  reducers: {
    setDoctorList(state,action){
      state.doctorList = action.payload;
      state.isCached = true;
      state.lastFetched = Date.now();
    }
    ,
    setCenterList(state,action){
      state.centerList = action.payload;
    },
    setSpeacialityList(state,action){
        state.speacialityList = action.payload;
    },
    clearDoctorCache(state) {
      state.serviceList = [];
      state.isCached = false;
      state.lastFetched = null;
    },
  },
});

export const { setDoctorList,setCenterList,setSpeacialityList, clearDoctorCache } = doctorSlice.actions;
export default doctorSlice.reducer;